/*
  Aanvullingen op de bewaarlijst: delen, printen en het tonen/verbergen
  van de omliggende blokken.

  De bewaarfunctie zelf blijft van het theme (assets/wishlist.js, met
  localStorage-key m-wishlist-products). Dit script raakt die opslag
  niet aan -- het leest hem alleen om te weten of de lijst gevuld is,
  en om een deelbare link te maken.

  Delen: de handles gaan als URL-parameter mee (?bewaard=a,b,c). Wie de
  link opent krijgt die producten in zijn eigen lijst gezet, waarna de
  parameter uit de URL wordt gehaald. Geen server, geen extra requests.

  Printen: window.print() met een print-stylesheet. Bewust geen
  pdf-bibliotheek -- die kost 100-300KB en levert hetzelfde op.
*/
(() => {
  const OPSLAG = 'm-wishlist-products';
  const wortel = document.querySelector('[data-solza-bewaard]');
  if (!wortel) return;

  const lees = () => {
    try {
      return Array.from(new Set(JSON.parse(localStorage.getItem(OPSLAG)) || []));
    } catch (e) {
      return [];
    }
  };

  const schrijf = (lijst) => {
    try {
      localStorage.setItem(OPSLAG, JSON.stringify(Array.from(new Set(lijst))));
    } catch (e) {
      /* opslag vol of geblokkeerd: dan doen we niets */
    }
  };

  // Gedeelde lijst uit de URL overnemen, vóór wishlist.js rendert.
  const params = new URLSearchParams(window.location.search);
  const gedeeld = params.get('bewaard');
  if (gedeeld) {
    const binnen = gedeeld
      .split(',')
      .map((h) => h.trim())
      .filter(Boolean);
    if (binnen.length) {
      schrijf(lees().concat(binnen));
      params.delete('bewaard');
      const schoon =
        window.location.pathname + (params.toString() ? '?' + params.toString() : '');
      window.history.replaceState({}, '', schoon);
      // wishlist.js leest localStorage bij het aanmaken van zijn instantie;
      // een herlaadbeurt is de betrouwbaarste manier om dat mee te krijgen.
      window.location.reload();
      return;
    }
  }

  const zetStaat = () => {
    const gevuld = lees().length > 0;
    wortel.classList.toggle('solza-bewaard--gevuld', gevuld);
    wortel.classList.toggle('solza-bewaard--leeg', !gevuld);
  };

  zetStaat();
  // wishlist.js verwijdert kaarten asynchroon; na een verwijdering opnieuw kijken.
  const observer = new MutationObserver(() => zetStaat());
  const raster = document.querySelector('.m-wishlist-page-content__wrapper');
  if (raster) observer.observe(raster, { childList: true });

  const deelKnop = wortel.querySelector('[data-bewaard-delen]');
  if (deelKnop) {
    const melding = wortel.querySelector('[data-bewaard-melding]');
    deelKnop.addEventListener('click', async () => {
      const handles = lees();
      if (!handles.length) return;
      const url =
        window.location.origin +
        window.location.pathname +
        '?bewaard=' +
        handles.map(encodeURIComponent).join(',');

      if (navigator.share) {
        try {
          await navigator.share({ title: document.title, url });
          return;
        } catch (e) {
          if (e && e.name === 'AbortError') return;
        }
      }
      try {
        await navigator.clipboard.writeText(url);
        if (melding) {
          melding.hidden = false;
          setTimeout(() => {
            melding.hidden = true;
          }, 4000);
        }
      } catch (e) {
        window.prompt(deelKnop.dataset.bewaardKopieer || 'Kopieer deze link:', url);
      }
    });
  }

  const printKnop = wortel.querySelector('[data-bewaard-print]');
  if (printKnop) {
    printKnop.addEventListener('click', () => window.print());
  }
})();
